export default "__VITE_ASSET__ad4e3154__"